<template>
  <div>
    <div v-if="shiftStore.data[location].shifts.length === 0" v-on:click="shiftStore.loadData(location, numOfShifts)">
      <br />
      Loading {{location}} Shifts...

    </div>
    <div v-else>
      <!-- <BasicTableComponent :list="data" :hideColumns="['RowID']">
        <div slot="header">{{location}}</div>
      </BasicTableComponent> -->
      <h3>{{location}}</h3>
      <BasicTableComponent 
          :list="shiftStore.daysWithTotals(location)" 
          :totals="shiftStore.monthTotals(location)"
          tableClass="table2excel"
          :tableID="location"
          
          :formatters="{
            'day' : ['d', 'ddd MM/DD/YY'], 
            'StartDateTime' : ['d', 'h:mm a'], 
            'EndDateTime' : ['d', 'h:mm a'], 
            'Start' : ['d', 'h:mm a'], 
            'End' : ['d', 'h:mm a'], 
            'Hours' : ['n', '0,0.00'], 
            'RoundedHours' : ['n', '0,0.00'], 
          }"
          :titles="{
            'StartDateTime' : 'Shift Start', 
            'EndDateTime' : 'Shift End', 
            'RoundedHours' : 'Rounded Hours',
          }"
        />
      
    </div>

  </div>
</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'ShiftSummaryTable',
  mixins : [formatDataMixin],
  inject: ['shiftsPage'],
  props : ['location', 'showDataEntry', 'showTransCounts', 'numOfShifts'],
  data () { return { 
    data: []
    } 
  },
  watch : {
    numOfShifts: function(){
      this.shiftStore.debounceLoadData(this.location, this.numOfShifts)
    }
  },
  created () {
    this.shiftStore.loadData(this.location, this.numOfShifts)
  },
  methods:{
    
    saveEdit(row){
      this.shiftStore.saveEdit(this.location, row);
    },
    shiftsMediaTypeForKey(row, key){
      return this.shiftStore.shiftsMediaTypeForKey(row, key)
    },
    shiftsMediaTypeCountForKey(row, key){
      return this.shiftStore.shiftsMediaTypeCountForKey(row, key)
    },
    overShort(row){
      return this.shiftStore.overShort(row)
    }
  },
  filters: {
    cleanShift: function(val){
      return val.replace('1001', '')
    }
  },
  computed:{
    
    shiftStore(){
      return this.shiftsPage.$refs.shiftStore;
    },
    
  }
}
</script>